module.exports = __webpack_public_path__ + "img/about5.5acfc8f.jpg";